module.exports = __webpack_public_path__ + "static/media/mq1White@3x.d08ef839.png";